export const CAMPAIGN_CATEGORIES = {
  announcement: {
    id: 'announcement',
    label: 'label.CAMPAIGN_CATEGORIES.ANNOUNCEMENT',
    description: 'label.CAMPAIGN_CATEGORIES.ANNOUNCEMENT_DESCRIPTION',
    value: 'announcement',
    checked: false
  },
  awareness: {
    id: 'awareness',
    label: 'label.CAMPAIGN_CATEGORIES.AWARENESS',
    value: 'awareness',
    description: 'label.CAMPAIGN_CATEGORIES.AWARENESS_DESCRIPTION',
    checked: false
  },
  casestudy: {
    id: 'casestudy',
    label: 'label.CAMPAIGN_CATEGORIES.CASE_STUDY',
    value: 'casestudy',
    description: 'label.CAMPAIGN_CATEGORIES.CASE_STUDY_DESCRIPTION',
    checked: false
  },
  education: {
    id: 'education',
    label: 'label.CAMPAIGN_CATEGORIES.EDUCATION',
    value: 'education',
    description: 'label.CAMPAIGN_CATEGORIES.EDUCATION_DESCRIPTION',
    checked: false
  },
  event: {
    id: 'event',
    label: 'label.CAMPAIGN_CATEGORIES.EVENT',
    value: 'event',
    description: 'label.CAMPAIGN_CATEGORIES.EVENT_DESCRIPTION',
    checked: false
  },
  holiday: {
    id: 'holiday',
    label: 'label.CAMPAIGN_CATEGORIES.HOLIDAY',
    value: 'holiday',
    description: 'label.CAMPAIGN_CATEGORIES.HOLIDAY_DESCRIPTION',
    checked: false
  },
  internal: {
    id: 'internal',
    label: 'label.CAMPAIGN_CATEGORIES.INTERNAL',
    value: 'internal',
    description: 'label.CAMPAIGN_CATEGORIES.INTERNAL_DESCRIPTION',
    checked: false
  },
  philanthropy: {
    id: 'philanthropy',
    label: 'label.CAMPAIGN_CATEGORIES.PHILANTHROPY',
    value: 'philanthropy',
    description: 'label.CAMPAIGN_CATEGORIES.PHILANTHROPY_DESCRIPTION',
    checked: false
  },
  product: {
    id: 'product',
    label: 'label.CAMPAIGN_CATEGORIES.PRODUCT',
    value: 'product',
    description: 'label.CAMPAIGN_CATEGORIES.PRODUCT_DESCRIPTION',
    checked: false
  },
  promo: {
    id: 'promo',
    label: 'label.CAMPAIGN_CATEGORIES.PROMOTION',
    value: 'promo',
    description: 'Discounts, bundles, time-limited deals',
    checked: false
  },
  recruiting: {
    id: 'recruiting',
    label: 'label.CAMPAIGN_CATEGORIES.RECRUITING',
    value: 'recruiting',
    description: 'label.CAMPAIGN_CATEGORIES.RECRUITING_DESCRIPTION',
    checked: false
  },
  survey: {
    id: 'survey',
    label: 'label.CAMPAIGN_CATEGORIES.SURVEY',
    value: 'survey',
    description: 'label.CAMPAIGN_CATEGORIES.SURVEY_DESCRIPTION',
    checked: false
  },
  webinar: {
    id: 'webinar',
    label: 'label.CAMPAIGN_CATEGORIES.WEBINAR',
    value: 'webinar',
    description: 'label.CAMPAIGN_CATEGORIES.WEBINAR_DESCRIPTION',
    checked: false
  }
};

export const CAMPAIGN_CATEGORIES_ARRAY = Object.keys(CAMPAIGN_CATEGORIES).map((key) => CAMPAIGN_CATEGORIES[key]);
